/** The default identity instance. Needs to match the default instance for the JS SDK */
export var DEFAULT_IDENTITY_INSTANCE = '$default_instance';
//# sourceMappingURL=identity.js.map